import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

export function Loading(): JSX.Element {
	return (
		<div
			className="rounded-2xl border-none bg-white p-6"
			id="social-media-content-container"
			data-qa="social-media-content-container"
			data-testid="social-media-content-loading-container"
		>
			<Loader role="progressbar" size="s" mb="20px" mx="auto" aria-label="progressbar" />
			<Text as="div" size="large" sx={{ textAlign: 'center' }}>
				<Translate value="corgi.petition.starter_dashboard.shared.share_visuals.modal_loading_copy" />
			</Text>
		</div>
	);
}
